export const SET_ALIGN_LOADING = "SET_ALIGN_LOADING";
export const UPDATE_ALIGN_LIST = "UPDATE_ALIGN_LIST";
export const UPDATE_ALIGN_OBJECT = "UPDATE_ALIGN_OBJECT";
